import { createClient } from 'contentful';

const isPreview = Boolean(
  ['true', true].includes(process.env.REACT_APP_PREVIEW_CONTENT!) && process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN
);

const host = isPreview ? 'preview.contentful.com' : undefined;

const contentfulConfig = {
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID!,
  accessToken: isPreview
    ? process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN!
    : process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN!,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master',
  retryOnError: false,
  host,
};

export const getContentfulClient = () => createClient(contentfulConfig);



// WEBPACK FOOTER //
// ./packages/platform-core/content/contentfulClient.ts